import { Box } from '@mui/system';
import React, { CSSProperties } from 'react';
import MediumTypography from '../formlib/MediumTypography';
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';
import CommentTextbox from '../formlib/CommentTextbox';

type QuestionsType = {
  id: string;
  type: string;
  displayQNoId: string;
  displayQueId: string;
  displayQNotext: string;
  displayQuetext: string;
};

type ASQQuestionConcernComponentType = {
  concernQuestions: QuestionsType[];
  onValueChange: (
    value: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => void;
  Value?: { commentId: number; comments: string }[];
  handlechange?: (
    value: { commentId: number; comments: string },
    index: number,
  ) => void;
  placeholder?: string;
  rows?: number;
  initialCheck?: { answer: string }[];
  customCommentStyles?: CSSProperties;
  labelidA?: string;
  defaultlabelidA?: string;
  labelidB?: string;
  defaultlabelidB?: string;
  disabled?: boolean;
};

const SimpleTextRadioButtonAndTextArea = ({
  concernQuestions,
  onValueChange,
  initialCheck,
  placeholder,
  Value,
  handlechange,
  rows,
  customCommentStyles,
  labelidA,
  labelidB,
  defaultlabelidA,
  defaultlabelidB,
  disabled,
}: ASQQuestionConcernComponentType) => {
  return (
    <Box>
      {concernQuestions?.map((questiondetails, index) => (
        <>
          {questiondetails.type === 'simpleQuestionRadioWithInput' && (
            <>
              <Box sx={{ alignItems: 'center', display: 'inline-flex' }}>
                <MediumTypography
                  sxProps={{ fontSize: 14, fontWeight: 500 }}
                  labelid={questiondetails.displayQNoId}
                  defaultlabel={questiondetails.displayQNotext}
                />
                <MediumTypography
                  sxProps={{
                    marginLeft: '4px',
                    marginRight: '24px',
                    fontFamily: 'Lato-Regular',
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                  labelid={questiondetails.displayQueId}
                  defaultlabel={questiondetails.displayQuetext}
                />
                <RadioGroup
                  onChange={(value) => onValueChange(value, index)}
                  row
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={initialCheck?.[index].answer}
                  name="radio-buttons-group"
                  sx={{ display: 'inline' }}
                >
                  <FormControlLabel
                    value="yes"
                    control={
                      <Radio
                        sx={{
                          '&.Mui-checked': { color: '#00C6B8' },
                          height: '24px',
                          borderRadius: '14px',
                          color: '#97A6A5',
                        }}
                        disabled={disabled}
                      />
                    }
                    label={
                      <MediumTypography
                        sxProps={{
                          fontWeight: 400,
                        }}
                        labelid={labelidA}
                        defaultlabel={defaultlabelidA}
                      />
                    }
                  />
                  <FormControlLabel
                    value="no"
                    control={
                      <Radio
                        sx={{
                          '&.Mui-checked': { color: '#00C6B8' },
                          height: '24px',
                          borderRadius: '14px',
                          color: '#97A6A5',
                        }}
                        disabled={disabled}
                      />
                    }
                    label={
                      <MediumTypography
                        sxProps={{
                          fontWeight: 400,
                        }}
                        labelid={labelidB}
                        defaultlabel={defaultlabelidB}
                      />
                    }
                  />
                </RadioGroup>
              </Box>
              <Box sx={{ paddingTop: '8px', width: '48%' }}>
                <CommentTextbox
                  name={questiondetails.displayQueId}
                  className="translate"
                  placeholder={placeholder}
                  rows={rows}
                  Value={Value?.[index] ? Value[index].comments : ''}
                  handlechange={(value) => {
                    if (handlechange) {
                      handlechange(
                        { commentId: index, comments: value },
                        index,
                      );
                    }
                  }}
                  maxLength={500}
                  style={{
                    ...customCommentStyles,
                  }}
                />
              </Box>
            </>
          )}
        </>
      ))}
    </Box>
  );
};

export default SimpleTextRadioButtonAndTextArea;
